import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import './styles/globals.css'
import './styles/mobile-viewport-fix-v2.css' // Mobile viewport fixes
import App from './App.tsx'
import { getDomainTenant } from '@/services/domainService'
import { applyThemeToDOM } from '@/utils/themeUtils'

// Polyfill Buffer for browser (required for csv-parse library)
import { Buffer } from 'buffer';
window.Buffer = Buffer;

// Load theme before React renders for immediate branding on login page
const initializeTheme = async () => {
  try {
    const domainTenant = await getDomainTenant();
    
    if (domainTenant?.theme) {
      // Apply theme settings immediately for pre-authentication branding
      applyThemeToDOM(domainTenant.theme);
      
      // Store in session for quick access by contexts
      sessionStorage.setItem('initial_domain_tenant', JSON.stringify(domainTenant));
    }
  } catch (error) {
    console.error('Failed to load domain theme:', error);
    // Continue loading app even if theme fails
  }
};

// Initialize theme before rendering React
initializeTheme().then(() => {
  const isDevelopment = import.meta.env.MODE === "development";

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      {isDevelopment ? (
        // Disable PostHog in development to avoid console noise
        <App />
      ) : (
        <PostHogProvider
          apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
          options={{
            api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
            capture_exceptions: true, // This enables capturing exceptions using Error Tracking
          }}
        >
          <App />
        </PostHogProvider>
      )}
    </StrictMode>,
  )
});